import { useEffect } from 'react';
import { PageContentNarrow } from '@commercetools-frontend/application-components';
import { ContentNotification } from '@commercetools-uikit/notifications';
import Spacings from '@commercetools-uikit/spacings';
import Text from '@commercetools-uikit/text';
import { u as useIsServedByProxy } from './use-is-served-by-proxy-a383da4b.esm.js';
import { g as getMcOrigin } from './get-mc-origin-fecfee07.esm.js';
import { l as location } from './location-f21dbc25.esm.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import '@commercetools-frontend/application-shell-connectors';
import '@babel/runtime-corejs3/helpers/slicedToArray';
import '@babel/runtime-corejs3/core-js-stable/url';
import '@babel/runtime-corejs3/core-js-stable/instance/reverse';

const RedirectToProjectCreate = () => {
  const servedByProxy = useIsServedByProxy();
  useEffect(() => {
    if (servedByProxy === true) {
      location.replace('/account/projects/new');
      return;
    }
  }, [servedByProxy]);
  if (servedByProxy) {
    return null;
  }
  const mcUrl = getMcOrigin(window.app.mcApiUrl);
  return jsx("div", {
    children: jsx(Spacings.Inset, {
      scale: "xl",
      children: jsx(PageContentNarrow, {
        children: jsxs(Spacings.Stack, {
          children: [jsx(Text.Headline, {
            as: "h1",
            children: "Please create a project!"
          }), jsx(ContentNotification, {
            type: "warning",
            children: "You are running in development mode"
          }), jsxs(Text.Body, {
            children: ["The application is not running behind the", ' ', jsx("a", {
              href: "https://docs.commercetools.com/merchant-center-customizations/concepts/merchant-center-proxy-router",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Merchant Center Proxy"
            }), ' ', "in production and thus cannot be redirected to the account section to create a new project."]
          }), jsxs(Text.Body, {
            children: ["Instead, we recommend to go to the", ' ', jsx("a", {
              href: mcUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Merchant Center production URL"
            }), ' ', "and create a project there. After that, you can access your new project from your local environment."]
          })]
        })
      })
    })
  });
};
RedirectToProjectCreate.displayName = 'RedirectToProjectCreate';

export { RedirectToProjectCreate, RedirectToProjectCreate as default };
